<template>
  <DashboardCard
      :border="false"
      :title="$t('widgets.brand.title')"
      :description="$t('widgets.brand.description')"
  >
    <template v-slot:table>
      <MDBTable borderless class="table-dashboard">
        <tbody>
          <tr
            v-for="(label, i) in labels"
            :key="i"
            class="border fs-12px"
          >
            <td>                <span
                class="legend-circle"
                :style="{ backgroundColor: colors[i] }"
            ></span>{{ label }}</td>
            <td>{{ percentages[i] }}</td>
          </tr>
        </tbody>
      </MDBTable>
    </template>

    <template v-slot:content>
      <div
          style="width: 200px; height: 200px;"
          class="p-2 mx-auto border rounded-circle shadow-circle mt-4"
      >
        <Doughnut :chart-data="chartData" :chart-options="chartOptions" :plugins="[centerTextPlugin]" />
      </div>
    </template>
  </DashboardCard>
</template>

<script setup>
import { computed, defineProps } from "vue";
import DashboardCard from "../User/Wholesaler/DashboardCard.vue";
import { MDBTable } from "mdb-vue-ui-kit";
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from "chart.js";
import { Doughnut } from "vue-chartjs";
import {createCenterTextPlugin} from "@/utils/chartPlugins";
import {useI18n} from "vue-i18n";

ChartJS.register(ArcElement, Tooltip, Legend);

const props = defineProps({
  data: { type: Object, required: true },
});

const { t } = useI18n();

const labels = ['Firestone', 'Bridgestone'];

const colors = ["#FF0230", "#000000"];

const chartData = computed(() => ({
  labels,
  datasets: [
    {
      data: [
        props.data.firestone,
        props.data.bridgestone,
      ],
      backgroundColor: colors,
      borderColor: "#fff",
      borderWidth: 2,
      spacing: 3,
    },
  ],
}));

const percentages = computed(() => [
  props.data.firestone_percent,
  props.data.bridgestone_percent,
])

const chartOptions = {
  responsive: true,
  cutout: "70%",
  plugins: {
    legend: { display: false },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (ctx) {
          const value = ctx.raw;
          return `${ctx.label}: ${value} (${percentages.value[ctx.dataIndex]}%)`;
        },
      },
    },
  },
};

const centerTextPlugin = createCenterTextPlugin(t("widgets.brand.centerTitle")
    , {
      color: "#000",
      weight: "700",
      divisor: 15,
    });
</script>

<style scoped lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/table_dashboard.scss";
</style>